(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["sr-personalisation"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('sr-personalisation')) {
    customElements.define('sr-personalisation', class extends HTMLElement {
      connectedCallback() {
        this.form = this.closest('form');
        this.field = this.querySelector('input');
        this.wrap = this.querySelector('[data-field-wrap]');
        this.plain = new Set(this.dataset.plainVariants.split(','));
        this.sync = () => {
          const plain = this.plain.has(this.form.elements.namedItem('id').value);
          this.wrap.hidden = plain;
          this.field.disabled = plain;
          this.field.required = !plain && this.dataset.mode !== 'optional-initial';
        };
        this.check = (event) => {
          this.sync();
          if (this.field.disabled) return;
          this.field.value = this.field.value.trim();
          if (this.dataset.mode !== 'name') this.field.value = this.field.value.toUpperCase();
          if (!this.field.reportValidity()) {
            event.preventDefault();
            event.stopImmediatePropagation();
          }
        };
        this.form.addEventListener('change', this.sync);
        this.form.addEventListener('submit', this.check, true);
        this.sync();
      }
      disconnectedCallback() {
        this.form?.removeEventListener('change', this.sync);
        this.form?.removeEventListener('submit', this.check, true);
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
